module.exports = __webpack_public_path__ + "static/media/ffu_logo.c6418439.svg";